module.exports = __webpack_public_path__ + "static/media/checkout-success_mobile.31312632.png";